export const RULE_DEFINE_STRING =
    '{"RuleName": "CaculateRule_template",' +
    '"Expression": "Result.T1.Normal == \'POS\' AND Result.T1.Lower <= 5 AND Result.T2.Lower >= 200",' +
    '"Actions": { "OnSuccess": { "Name": "OutputExpression",' +
    '"Context": { "Expression": "Result.T1.Normal + Result.T2.Lower zzz" }' +
    '}} }';
